import Thumbnail, { ThumbnailProps } from "../Thumbnail";

type EventThumbnailProps = ThumbnailProps;
export function EventThumbnail(props: EventThumbnailProps) {
  return <Thumbnail className="aspect-[1280/486]" {...props} />;
}
